import GoponRes from '../gopon-res.model';
import { Branch } from "@core/models";

export class BaseAuthReq {
  DeviceId: string = localStorage.getItem('uId') ?? '';
  DeviceToken: string = localStorage.getItem('oTokenId') ?? '-';
  IsAndroidDevice: boolean = false;
  IsIOSDevice: boolean = false;
  IsWeb: boolean = true;
}
export class AppSettingReq extends BaseAuthReq {
  CartId: number = 0;
  AppVersion: string = '1.0';
  DeviceName: string = 'web';
  DeviceModel: string = 'web';
  StartupTutorials: boolean = true;
}
export interface AppSetting {
  TargetAppVersion: string;
  UpdateIsRequired: boolean;
  CartCount: number;
  NotificationCount: number;
  HomeSettings: HomeSetting;
  StartupTutorials: StartupTutorial[];
}
export interface AppSettingRes extends GoponRes, AppSetting {}
export interface HomeSetting {
  ShowTopBanner: boolean;
  ShowBottomBanner: boolean;
  ShowMostSelling: boolean;
  ShowNewProducts: boolean;
  HomeCategories: HomeCategorie[];
}
export interface HomeCategorie {
  Id: number;
  CategoryName: string;
  CategoryRole: string;
}
export interface StartupTutorial {
  Id: number;
  Name: string;
  RoleKey: string;
  Banners: Banner[];
}
/*export interface Banner {
  Id: number;
  Name: string;
  Image: string;
  BannersGroupId: 4;
  BannersGroupName: string;
  ShortDetails: string;
}*/
export interface BannerRes extends GoponRes {
  Items: BannerItem[];
}
export interface BannerItem {
  Id: number;
  Name: string;
  RoleKey: 'TopBanners' | 'BottomBanners'| 'AdsBanner';
  Banners: Banner[];
}
export interface Banner {
  Id: number;
  Type: number;
  RefId: string;
  Name: string;
  Image: string;
  BannersGroupId: number;
  BannersGroupName: string;
  ShortDetails: string;
}
export interface BranchesRes extends GoponRes {
  Branches: Branch[];
}

export interface LoginForm {
  username: string;
  password: string;
}

export interface AuthState {
  token?: string;
  type: number;
  status: boolean;
  Customer?: Customer;
  exp?: number;
}
export interface Customer {
  Address: string;
  AreaId: string;
  BranchId: number;
  DateOfBirth: string;
  Email: string;
  EmailConfirmed: boolean;
  FirstName: string;
  IsActive: boolean;
  IsSocial: boolean;
  LastName: string;
  PhoneCode: string;
  PhoneNumber: string;
  PhoneNumberConfirmed: boolean;
  Token: string;
  UserType: number;
  UserTypeName: 'Guest' | 'Branch admin' | 'Customer';
  areas: Area[];
}
export interface Area {
  Id: number;
  Name: string;
  CityId: number;
  CityName: string;
  CountryId: number;
  CountryName: string;
  LanguageId: number;
  Status: boolean;
  ParentId: number;
}

export class ContinueAsGuest extends BaseAuthReq {}

export class LoginReq extends BaseAuthReq {
  email!: string;
  password!: string;
}
export class LoginSocialReq extends BaseAuthReq {
  SocialMediaType!: 'google' | 'facebook' | string;
  SocialAuthID!: string;
}
export interface LoginRes extends GoponRes {
  Customer: Customer;
}
export interface Profile extends GoponRes {
  Customer: Customer;
  Areas: Area[];
}
export class UpdateProfileReq {
  firstName!: string;
  lastName!: string;
  phoneCode!: string;
  phoneNumber!: string; // unique
  email!: string; // unique
  dateOfBirth!: string; // date format like 1/24/2022 [optional]
  areaId?: number; // [optional]
  address?: string; //[optional]
  DeviceId: string = localStorage.getItem('uId') ?? '';
  DeviceToken: string = localStorage.getItem('oTokenId') ?? '-';
}
export class RegisterReq extends BaseAuthReq {
  firstName!: string;
  lastName!: string;
  phoneCode!: string;
  phoneNumber!: string;
  email!: string;
  password!: string;
  dateOfBirth?: string;
}
export interface RegisterRes extends GoponRes {
  Token: string;
  Customer: Customer;
}
export class VerifyActivationCodeReq extends BaseAuthReq {
  code!: string;
}
export class ActivationCodeReq {
  email?: string;
  phoneNumber?: string;
  phoneCode?: string;
  isForMobile: boolean = false;
  isForEmail: boolean = false;
  isForBoth: boolean = false;
}
export interface CouponItem {
  OrderId: string;
  OrderStatus: string;
  ServiceCouponCode: string;
  OrderDate: null;
  ServiceCouponStatus: string;
  IsServiceCouponCodeApplied: string;
  BranchName: string;
  ItemName: string;
  ItemPrice: number;
  ItemPriceTitle: string;
  Logo: string;
  ExpirationDate: string;
}
export interface CouponsRes extends GoponRes {
  Items: CouponItem[];
  Item: CouponItem;
  BranchName: string;
}
